// Charte de la part de CA d'une heure, source de vérité partagée entre la colonne CA du widget
// « Couverture planning » du dashboard RH (back-office) et la colonne « ca » du planning StoreApp.
// 8 paliers (hex exacts client), seuils ABSOLUS de part de CA, pas relatifs au max de la grille :
//   0 % -> idx0 ; 1 % -> idx1 ; 2 % -> idx2 ; 3 % -> idx3 ; [4 %, 10 %[ -> idx4 ;
//   [10 %, 15 %[ -> idx5 ; [15 %, 25 %[ -> idx6 ; >= 25 % -> idx7.
export const caShareRamp = [
  '#E8F2E4',
  '#CEE3C4',
  '#B8D9A8',
  '#A4C494',
  '#86AB7D',
  '#6A9560',
  '#4F6A47',
  '#354A31',
] as const

// Seuils en fraction 0..1 de part de CA, N-1 seuils pour N paliers. Bord inclusif : atteindre un
// seuil fait passer au palier supérieur (3 % pile -> palier 3).
export const caShareThresholds = [0.01, 0.02, 0.03, 0.04, 0.1, 0.15, 0.25] as const

const caShareDarkText = '#072C1A'
const caShareLightText = '#FFFFFF'

// Style d'une cellule pour une part de CA 0..1 : palier 0 si la part est nulle ou négative, sinon
// le nombre de seuils atteints. Texte blanc sur les 2 paliers les plus foncés (#4F6A47 / #354A31),
// vert foncé sinon (contraste).
export const caShareCellStyle = (caShare: number): { backgroundColor: string; color: string } => {
  const idx =
    caShare <= 0 ? 0 : caShareThresholds.reduce((acc, t) => (caShare >= t ? acc + 1 : acc), 0)
  return {
    backgroundColor: caShareRamp[idx],
    color: idx >= caShareRamp.length - 2 ? caShareLightText : caShareDarkText,
  }
}
